import { Loader } from "@googlemaps/js-api-loader"
import { MEDIUM_SCREEN } from '../consts';


const DEFAULT_MAP_OPTIONS = {
  zoom: 16,
  rotateControl: true,
  fullscreenControl: false,
};

export default (key, lat, lng, icon, language='en') => ({
  showStaticMap: true,
  key: key,
  lat: lat,
  lng: lng,
  icon: icon,
  language: language,
  isMobile: window.innerWidth < MEDIUM_SCREEN,
  coordinates: { lat: parseFloat(lat), lng: parseFloat(lng) },
  get staticMapUrl() {
    const baseUrl = 'https://maps.googleapis.com/maps/api/staticmap';
    const params = {
      center: `${this.lat},${this.lng}`,
      zoom: DEFAULT_MAP_OPTIONS.zoom,
      markers: `icon:${window.location.origin}${this.icon}|${this.lat},${this.lng}`,
      key: this.key,
      size: '700x700',
      language: this.language,
    };
    const query = Object.keys(params);
    return `${baseUrl}?${query
      .map((key) => `${key}=${params[key]}`)
      .join('&')}`;
  },

  get dynamicMapInit() {
    if (this.showStaticMap === false) {
      return;
    }
    this.showStaticMap = false;
    const loader = new Loader({
      apiKey: this.key,
      version: "weekly",
      language: this.language,
    });
    loader.load().then(() => {
      const MAP_OPTIONS = {
        desktop: {
          ...DEFAULT_MAP_OPTIONS,
          zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_BOTTOM,
          },
          streetViewControlOptions: {
            position: google.maps.ControlPosition.LEFT_BOTTOM,
          },
          mapTypeControlOptions: {
            position: google.maps.ControlPosition.TOP_CENTER,
          },
          center: this.coordinates,
        },
        mobile: {
          ...DEFAULT_MAP_OPTIONS,
          mapTypeControlOptions: {
            position: google.maps.ControlPosition.TOP_CENTER,
          },
          center: this.coordinates,
        },
      };
      const map = new google.maps.Map(this.$refs.dynamicMap, this.isMobile ? MAP_OPTIONS.mobile: MAP_OPTIONS.desktop);
      // marker
      new google.maps.Marker({
        position: this.coordinates,
        map: map,
        icon: `${window.location.origin}${this.icon}`,
      });
  });
  },
});
